import React, { useState } from 'react'
import PropTypes from 'prop-types'
import useIsMobile from '../Layouts/Viewport'
import Backdrop from './Backdrop'
import Typography from '../Basics/Typography'
import {
  Layout,
  Main,
  MainContent,
  SidebarWrapper,
} from './AdminLayout.styles'

const DEFAULT_TITLE_MARGIN = '.5rem 0 0'
const DEFAULT_TITLE_MARGIN_MOBILE = '1rem 0 0'

const AdminLayout = ({
  children,
  header,
  sidebar,
  title,
  description,
  titleMargin = DEFAULT_TITLE_MARGIN,
  titleMarginMobile = DEFAULT_TITLE_MARGIN_MOBILE,
}) => {
  const isMobile = useIsMobile()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  return (
    <>
      <Layout>
        <SidebarWrapper open={isSidebarOpen}>
          {sidebar}
        </SidebarWrapper>
        <Main>
          {header &&
            React.cloneElement(header, {
              onToggleSidebar: () => setIsSidebarOpen(p => !p),
              isMobile
            })
          }
          <MainContent
            $titleMargin={titleMargin}
            $titleMarginMobile={titleMarginMobile}
          >
            {title != null && title !== '' && (
              <Typography margin="0" variant="h1">
                {title}
              </Typography>
            )}
            {description != null && description !== '' && (
              <Typography variant="subtitle">{description}</Typography>
            )}
            {children}
          </MainContent>
        </Main>
      </Layout>
      {isMobile && isSidebarOpen && (
        <Backdrop onClick={() => setIsSidebarOpen(false)} />
      )}
    </>
  )
}

AdminLayout.propTypes = {
  children: PropTypes.node,
  header: PropTypes.element,
  sidebar: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.node,
  titleMargin: PropTypes.string,
  titleMarginMobile: PropTypes.string,
}

export default AdminLayout
